import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    image: 'https://cdn.magicpatterns.com/uploads/wTdjBHyMhbCbNbqYzzX8ku/imagen_2.webp',
    title: 'MAESTRÍA TÉCNICA',
    checks: ['Más precisión en el armado', 'Acabados profesionales'],
    badge: 'BASE TÉCNICA'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/3n2HHvKFCQ6F68tQ5EBU7N/imagen_10.webp',
    title: 'EFECTO WOW',
    checks: ['Profundidad infinita real', 'Iluminación perfecta'],
    badge: 'RESULTADOS REALES'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/7UuJuCytxm3m65uyKHoQh7/imagen1.webp',
    title: 'NEGOCIO RENTABLE',
    checks: ['Vende tus piezas a precios premium', 'Aumenta tu margen de ganancia', 'Mejor imagen de marca'],
    badge: 'MÁXIMA RENTABILIDAD'
  }];
  return <section className="py-10 bg-[#0a0514] relative overflow-hidden" data-id="element-407">
      <div className="max-w-7xl mx-auto px-4 relative z-10" data-id="element-408">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-black text-center text-white mb-16 tracking-tight uppercase" data-id="element-409">
          LO QUE TE LLEVÁS CON{' '}
          <span className="text-[#11F15E]" data-id="element-410">SIN FIN STUDIO</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-411">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-[#130a2a] rounded-3xl overflow-hidden border border-white/5 flex flex-col h-full" data-id="element-412">
              {/* Image with gradient overlay */}
              <div className="relative h-64 overflow-hidden" data-id="element-413">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover" data-id="element-414" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#130a2a] via-transparent to-transparent" data-id="element-415" />
              </div>

              {/* Content */}
              <div className="p-8 flex flex-col flex-grow" data-id="element-416">
                <h3 className="text-xl font-bold text-white mb-6 tracking-wide uppercase" data-id="element-417">
                  {item.title}
                </h3>

                <ul className="space-y-4 mb-10 flex-grow" data-id="element-418">
                  {item.checks.map((check, j) => <li key={j} className="flex items-start gap-3" data-id="element-419">
                      <div className="mt-1 bg-yellow-400/20 rounded-full p-0.5" data-id="element-420">
                        <CheckIcon className="w-4 h-4 text-yellow-400" data-id="element-421" />
                      </div>
                      <span className="text-gray-300 text-sm font-medium leading-tight" data-id="element-422">
                        {check}
                      </span>
                    </li>)}
                </ul>

                {/* Badge/Button */}
                <div className="mt-auto" data-id="element-423">
                  <div className="inline-block px-6 py-2 rounded-full bg-blue-600/10 border border-blue-500/30 text-blue-400 text-[10px] font-bold tracking-widest uppercase" data-id="element-424">
                    {item.badge}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}